module.exports = __webpack_public_path__ + "media/MRI1A.8eaac56a.mp3";